import { RETRIEVE_USERS_BY_JOB_ROLE, ASSIGN_USER_TO_JOB, UNASSIGN_USER_FROM_JOB } from '../actions/types';

const initialState = {
    users: [],
};

function userJobReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_USERS_BY_JOB_ROLE:
            return {
                ...state,
                users: payload,
            };

        case ASSIGN_USER_TO_JOB:
            return {
                ...state,
                users: [...state.users, payload],
            };

        case UNASSIGN_USER_FROM_JOB:
            return {
                ...state,
                users: state.users.filter((user) => user.user_job_role_id !== payload),
            };

        default:
            return state;
    }
}

export default userJobReducer;
